/*
*   Данные и логика по правилам расчета стоимости доставки (скидки/наценки)
*/
import router from '@/router/index';
import ajaxRequest from '@/utils/request';
import { rules } from '@/tests/testData';

const state = {
    loaded: false,
    costRules: [],
    deliveryPaymentTypes: []
};

const getters = {
    costRules: state => state.costRules,
    deliveryPaymentTypes: state => state.deliveryPaymentTypes
};

const actions = {
    loadCostRules(context) {
        ajaxRequest({
            url: '/cost_rules/get/',
            success(response) {
                context.commit('loadCostRules', response.data);
            }
        });
    },
    loadDeliveryPaymentTypes(context) {
        ajaxRequest({
            url: '/delivery_payment_types/get/',
            success(response) {
                context.commit('loadDeliveryPaymentTypes', response.data);
            }
        });
    },
    saveCostRule(context, {costRule, markInvalid}) {
        ajaxRequest({
            url: '/cost_rules/save/',
            method: 'POST',
            params: costRule,
            success({created, data}) {
                context.commit('saveCostRule', {created, data});
            },
            failure(response) {
                markInvalid(response.errors);
            }
        });
    },
    deleteCostRule(context, costRule) {
        ajaxRequest({
            url: '/cost_rules/delete/',
            method: 'POST',
            params: costRule,
            success(response) {
                context.commit('deleteCostRule', costRule);
            }
        });
    }
};

const mutations = {
    loadCostRules(state, data) {
        state.loaded = true;
        state.costRules = data;
    },
    loadDeliveryPaymentTypes(state, data) {
        state.deliveryPaymentTypes = data;
    },
    saveCostRule(state, {created, data}) {
        if (!created) {
            let old = state.costRules.findIndex(item => item.id === data.id);
            state.costRules.splice(old, 1);
        }
        let index = state.costRules.findIndex(
            item => (item.id < data.id && item.active === data.active)
        );
        state.costRules.splice(index, 0, data);

        this.commit('changeEditedCostRule', data);
        router.push({name: 'CostRules'});
    },
    deleteCostRule(state, costRule) {
        let old = state.costRules.findIndex(item => {
            return item.id === costRule.id;
        });
        state.costRules.splice(old, 1);

        this.commit('changeEditedCostRule', {...costRule, id: null});
        router.push({name: 'CostRules'});
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/costRules.js